import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useParticipanteService() {
    const { publicFetch, authenticatedFetch } = useApi();

    const criarParticipante = async (dados) => {
        const response = await publicFetch(URLS.CREATE_PARTICIPANTE, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const atualizarParticipante = async (dados) => {
        const response = await authenticatedFetch(URLS.UPDATE_PARTICIPANTE, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const geraCodigoRecuperacaoParticipante = async (dados) => {
        const response = await publicFetch(URLS.GEN_COD_RECUPERACAO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const atualizarSenhaParticipante = async (dados) => {
        const response = await publicFetch(URLS.VER_COD_RECUPERACAO, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const deletarParticipante = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_PARTICIPANTE, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const listarParticipantes = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_PARTICIPANTE);

        return response.json();
    };

    const obterParticipantePorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_PARTICIPANTE, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const obterParticipantePorCelular = async (celular) => {
        const response = await publicFetch(URLS.READ_BY_CELULAR_PARTICIPANTE, {
            method: 'POST',
            body: JSON.stringify({ celular }),
        });

        return response.json();
    };

    const listarParticipantesPorTurma = async (idTurma) => {
        const response = await authenticatedFetch(URLS.READ_ALL_PARTICIPANTE_BY_TURMA, {
            method: 'POST',
            body: JSON.stringify({ idTurma }),
        });

        return response.json();
    };

    return {
        criarParticipante,
        atualizarParticipante,
        geraCodigoRecuperacaoParticipante,
        atualizarSenhaParticipante,
        deletarParticipante,
        listarParticipantes,
        obterParticipantePorId,
        obterParticipantePorCelular,
        listarParticipantesPorTurma,
    };
}